// import component library's theme
import { DefaultTheme as libraryTheme } from '@dsny/dsny-component-library'

const { name, ...themes } = libraryTheme
const theme = {
  // all settings inherited from library: colours, fonts, ...
  ...themes,

  fonts: {
    ...themes.fonts
  },

  colors: {
    ...themes.colors,

    // local specific colours
    platinum: '#E2E6EA',
    lightRed: '#F8D7DA',
    lightRedTwo: '#f5c6cb',
    player30: '#16386C',
    player50: '#6397E4',
    neutralC20: '#2A2C2E',
    error70: '#E95D5D',
    error20: '#3B0707'
  },

  // local-specific styles
  padding: {
    modalBodyPadding: '16px 32px 16px 32px'
  }
}

// Export new theme under original name of "theme", which will be provided to all application by ThemeProvider
export default theme
